import { ServerClusterInfo } from '@/api/type-server'

export interface CreateTime {
  seconds: number
}

export class Network {
  resID: string
  name: string
  createTime: CreateTime
  clusterType: number
  domain: number
  capacity: ServerClusterInfo['capacity']

  constructor(props: ServerClusterInfo) {
    this.resID = props.resID
    this.name = props.name
    this.createTime = props.createTime
    this.clusterType = props.clusterType
    this.domain = props.domain
    this.capacity = props.capacity
  }
}

export enum EndpointStatus {
  InvalidStatus = 0,
  Syncing,
  Avail,
  Removing,
  Removed,
}

export const endpointStatusMap = {
  [EndpointStatus.InvalidStatus]: {
    label: 'Unknown',
    style: 'status-grey',
  },
  [EndpointStatus.Syncing]: {
    label: 'Unknown',
    style: 'status-grey',
  },
  [EndpointStatus.Avail]: {
    label: 'Unknown',
    style: 'status-grey',
  },
  [EndpointStatus.Removing]: {
    label: 'Unknown',
    style: 'status-grey',
  },
  [EndpointStatus.Removed]: {
    label: 'Unknown',
    style: 'status-grey',
  },
}

export const endpointNetStatusMap = {
  [EndpointStatus.InvalidStatus]: {
    label: 'Unknown',
    style: 'status-grey',
  },
  [EndpointStatus.Syncing]: {
    label: 'Connecting',
    style: 'text-btn-secondary',
  },
  [EndpointStatus.Avail]: {
    label: 'Connected',
    style: 'text-success',
  },
  [EndpointStatus.Removing]: {
    label: 'Disconnecting',
    style: 'text-secondary',
  },
  [EndpointStatus.Removed]: {
    label: 'Unknown',
    style: 'text-secondary',
  },
}
